/******************************************************************************
 * Copyright (c) 2016 - 2024.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2024-08-28                                                        *
 ******************************************************************************/

export const CATEGORY_ASSIGNMENT_UI_TEMPLATES =  {
    BTO_CLASSIC: {label:'Open Configurator',value:'BTO_CLASSIC'},
    NON_BTO_CLASSIC: {label:'Offer List',value:'NON_BTO_CLASSIC'},
    NON_BTO_CLASSIC_WITH_STOCK: {label:'Offer List with Availability',value:'NON_BTO_CLASSIC_WITH_STOCK'},
    NON_BTO_CARDS: {label:'Offer Cards',value:'NON_BTO_CARDS'}
};

export const CATEGORY_ASSIGNMENT_UI_TEMPLATE_OPTIONS = [
    CATEGORY_ASSIGNMENT_UI_TEMPLATES.BTO_CLASSIC,
    CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CLASSIC,
    CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CLASSIC_WITH_STOCK,
    CATEGORY_ASSIGNMENT_UI_TEMPLATES.NON_BTO_CARDS,
];
